/*
 * JSON 직렬화 기반 깊은 복사. 구 Object.prototype.copyOfValue 대체.
 *
 * 레거시와 동일하게 JSON 왕복을 사용하므로 Date/함수/undefined 필드는 보존되지
 * 않는다 (Date → ISO 문자열). 기존 호출부가 모두 이 동작을 전제로 하므로
 * structuredClone 으로 바꾸지 않는다.
 */
export const deepCopy = <T>(value: T): T | undefined => {
  if (value === null || value === undefined) {
    return undefined
  }
  return JSON.parse(JSON.stringify(value))
}
